import { render } from "./CartsShow.vue?vue&type=template&id=d5fc4852"
import script from "./CartsShow.vue?vue&type=script&lang=js"
export * from "./CartsShow.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__